export function addCharliAttribution(url, origin) {
  if (typeof url !== "string" || !url.trim() || url.trimStart().startsWith("#")) {
    return url;
  }

  try {
    const currentOrigin = new URL(origin);
    if (!["http:", "https:"].includes(currentOrigin.protocol)) {
      return url;
    }

    const destination = new URL(url, currentOrigin.origin);
    if (!["http:", "https:"].includes(destination.protocol)) {
      return url;
    }
    if (destination.origin !== currentOrigin.origin) {
      return url;
    }

    destination.searchParams.set("c", "1");

    const isAbsolute = /^[a-zA-Z][a-zA-Z\d+.-]*:/.test(url) || url.startsWith("//");
    if (isAbsolute) {
      return destination.href;
    }

    return `${destination.pathname}${destination.search}${destination.hash}`;
  } catch {
    return url;
  }
}
